"use strict";angular.module("debounce",[]).service("debounce",["$timeout",function(a){return function(b,c,d,e){function f(){i=this,h=arguments;var f=function(){g=null,d||(j=b.apply(i,h))},k=d&&!g;return g&&a.cancel(g),g=a(f,c,e),k&&(j=b.apply(i,h)),j}var g,h,i,j;return f.cancel=function(){a.cancel(g),g=null},f}}]).directive("debounce",["debounce","$parse",function(a,b){return{require:"ngModel",priority:999,link:function(c,d,e,f){var g,h,i=b(e.debounce)(c),j=!!b(e.immediate)(c),k=f.$render.bind(f),l=a(function(a){h=!0,f.$$lastCommittedViewValue=g,f.$setViewValue(a),h=!1},parseInt(i,10),j);f.$render=function(){k(),l.cancel(),g=this.$viewValue},f.$parsers.unshift(function(a){return h?(g=a,a):(l(f.$viewValue),g)})}}}]),angular.module("angular.media",["debounce"]).run(["$rootScope","$media",function(a,b){a.$media=b}]),angular.module("angular.media").service("$media",["mediaQueries","$rootScope","$window","debounce",function(a,b,c,d){var e={},f=function(){var d;_(a).forEach(function(b,f){var g=e[f],h=c.matchMedia(a[f]).matches;e[f]=h,d=d||g!==h}),d&&b.$broadcast("mediaQueriesChanged",e)},g=d(function(){f(),b.$apply()},200);return angular.element(c).bind("resize",function(){g()}),f(),{query:function(b){return this.raw(a[b])},raw:function(a){return c.matchMedia(a).matches},predefinedQueriesStatus:e}}]),angular.module("angular.media").provider("mediaQueries",function(){var a={phone:"(max-width:480px)",tablet:"(min-width:481px) and (max-width:979px)",laptop:"(min-width:980px) and (max-width:1279px)",desktop:"(min-width:1280px)"};this.$get=function(){return a},this.setPreDefinedQueries=function(b){this.shortcuts=angular.extend(a,b)}});

(function() {
  'use strict';

  angular
    .module('source', ['ngAnimate', 'ngMessages', 'ngTouch', 'restangular', 'ui.router', 'angular.media']);

})();

(function() {
  'use strict';

  angular
    .module('source')
    .directive('modalSection', modalSection);

  /** @ngInject */
  function modalSection() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        active: '=',
        content: '='
      },
      templateUrl: 'app/components/modal/modalSection.html'
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('source')
    .directive('modal', modal);

  /** @ngInject */
  function modal($compile) {
    return {
      restrict: 'E',
      scope: {
        title: '@',
        subTitle: '@',
        sections: '='
      },
      replace: true,
      templateUrl: 'app/components/modal/modal.html'
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('source')
    .directive('bounce', bounce);

  /** @ngInject */
  function bounce() {
    return {
      restrict: 'C',
      link: function (scope, element, attr) {
        element
          .velocity({ top: '-=5px' }, { loop: true, duration: 200, delay: 3000})
          .velocity('reverse', {loop: true, delay: 0})
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('source')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController(Restangular) {
    var vm = this;

    var defaults = {
      name: '',
      company: '',
      email: '',
      message: ''
    }

    vm.contact = angular.copy(defaults);

    // // init controller
    // var controller = new ScrollMagic.Controller();

    // // create a scene
    // var scene = new ScrollMagic.Scene({triggerElement: "#solution"})
    //     // .setPin("#solution") // pins the element for the the scene's duration
    //     .addIndicators()
    //     .addTo(controller); // assign the scene to the controller

    vm.submit = function(form) {
      Restangular.all('submit').post(vm.contact)
      .then(function(){
        vm.submitSuccessful = true;
        vm.contact = angular.copy(defaults);
        form.$setPristine();
        form.$setUntouched();
      });
    }

    vm.scrollTo = function(section) {
      $(section)
        .velocity('scroll', { duration: 1000, easing: 'easeInOutCirc' });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('source')
    .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      link: function(scope, element) {
        var windowEl = angular.element(element),
            bodyList = element.find('.body'),
            sectionCount, title, image, scrollPos;

        var handler = function() {
          var index = 0;
          do {
            index++;
          } while (bodyList[index].getBoundingClientRect().top < 0);
          console.log(index);
        };

        windowEl.on('scroll', scope.$apply.bind(scope, handler));

        scope.$on('$destroy', function() {
          windowEl.off('scroll');
        })
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('source')
    .directive('onFinishRender', onFinishRender);

  /** @ngInject */
  function onFinishRender($timeout) {
    return {
      restrict: 'A',
      link: function (scope, element, attr) {
        if (scope.$last === true) {
          $timeout(function () {
            scope.$eval(attr.onFinishRender);
          });
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('source')
    .run(runBlock);

  /** @ngInject */
  function runBlock($rootScope) {

  }

})();

(function() {
  'use strict';

  angular
    .module('source')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $locationProvider, $urlRouterProvider) {
    $locationProvider.html5Mode(false);
    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('home', {
        url: '/',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'vm'
      });
      // .state('projects', {
      //   parent: 'home',
      //   url: 'projects',
      //   controller: 'ProjectsController',
      //   controllerAs: 'vm',
      //   templateUrl: 'app/projects/projects.html'
      // })
      // .state('projects.detail', {
      //   url: '/:id',
      //   controller: 'ProjectsDetailController',
      //   controllerAs: 'vm',
      //   templateUrl: 'app/projects/projectsDetail.html'
      // });
  }

})();

(function() {
  'use strict';

  angular
    .module('source')
    .constant('_', window._);

})();

(function() {
  'use strict';

  angular
    .module('source')
    .config(config);

  /** @ngInject */
  function config($logProvider, RestangularProvider) {
    // Enable log
    $logProvider.debugEnabled(true);
    RestangularProvider.setBaseUrl('https://us-central1-nicktouchette-api.cloudfunctions.net');
    RestangularProvider.setDefaultHeaders({'Content-Type' : 'application/json'});
  }

})();

angular.module('source').run(['$templateCache', function($templateCache) {$templateCache.put('app/main/main.html','<div id=landing><img class=vignette src=./assets/images/vignette.png><div class=container><img class="monogram center-both" src=./assets/images/monogram.png><img class="landing-text center-both" src=./assets/images/landing-text.png></div><div class="more bounce" ng-click=vm.scrollTo(&quot;#stack&quot;)><span>Scroll</span><img src=./assets/images/landing-more.png></div></div><div id=stack><img class="header center" src=./assets/images/stack-header.png><img class="brands center" src=./assets/images/stack-brands.png></div><div id=solution><img class="header center" src=./assets/images/solution-header.png><div class="points center"><img class=point src=./assets/images/solution1.png><img class=point src=./assets/images/solution2.png><img class=point src=./assets/images/solution3.png><img class=point src=./assets/images/solution4.png><img class=point src=./assets/images/solution5.png><img class=point src=./assets/images/solution6.png></div></div><div id=footer><img class="background center" src=./assets/images/footer-text.png><div class="sites center"><a href=mailto:touchette@gmail.com><img src=./assets/images/footer-mail.png></a><a href=http://www.github.com/nicktouchette><img src=./assets/images/footer-github.png></a><a href=http://www.linkedin.com/in/nicktouchette/ ><img src=./assets/images/footer-linkedin.png></a></div></div>');
$templateCache.put('app/components/modal/modal.html','<div class=modal><div class=inner-body><div class=header><div class=name>{{title}}</div><div class=skill>{{subTitle}}</div></div><div class=image><img ng-src="{{scroll.image || sections[0].image}}"></div><div class=content><div class=wrapper scroll-position=scroll><modal-section ng-repeat="section in ::sections" active="scroll.position === section.title" content=::section on-finish-render=init()></modal-section></div></div><div class=aside ng-if="sections.length &gt; 1"><ul><li ng-repeat="section in ::sections" ng-class="{&quot;active&quot;: scroll.position === section.title}">{{section.icon || section.title}}</li></ul></div></div></div>');
$templateCache.put('app/components/modal/modalSection.html','<div class=body data-title={{content.title}} data-image={{content.image}}><div class=title ng-if=active>{{content.title}}.</div><div class=text><p>{{content.body}}</p></div></div>');}]);